var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgZoominfo = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E3E3E3",
    d: "M33.434 7.243c-.001-.328-.1-.553-.389-.7h-6.822c-.287.178-.4.43-.381.773.016.286.012.573.009.86q-.003.188-.004.376c0 .792.114.905.912.906h1.657a.9.9 0 0 1-.252.348.573.573 0 0 0-21.652 21.043 51 51 0 0 0-.003 2.085c.007.418.17.564.602.564q3.794.005 7.587 0c.419 0 .576-.156.582-.582q.012-.831.001-1.661c-.005-.471-.147-.604-.63-.605h-3.914L30.6 11.52l-.001.606c0 .43-.002.828.002 1.224.004.411.172.582.585.587a79 79 0 0 0 1.61 0c.486-.002.63-.153.63-.65v-1.7c-.001-1.442-.003-2.884.008-4.326z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    fillRule: "evenodd",
    d: "M22.18 6.5c.285.178.392.424.372.758-.026.438-.005.88-.007 1.32-.003.53-.164.688-.722.69q-1.142.004-2.284.002H9.385v.428l-.001 3.43c0 .513-.161.665-.699.667q-.774.005-1.55 0c-.453-.005-.626-.152-.628-.577-.006-2.036.001-4.071-.007-6.106-.001-.31.148-.489.412-.612zm8.5 24.004v-4.269c.001-.623.128-.76.709-.76.51-.001 1.018-.004 1.527 0 .425.004.582.163.582.603q.005 3.408 0 6.817c0 .44-.156.603-.58.604q-6.72.003-13.439 0c-.419 0-.569-.167-.571-.614q-.005-.872 0-1.745c.001-.506.127-.636.616-.636z",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgZoominfo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/zoominfo.d907a62e.svg";